"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.letterSpacings = void 0;
var letterSpacings_1 = __importDefault(require("../tokens/letterSpacings"));
exports.letterSpacings = letterSpacings_1.default;
//# sourceMappingURL=letterSpacings.js.map